import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=50879cbe&scoped=true&"
import script from "./svgIcon.vue?vue&type=script&lang=js&"
export * from "./svgIcon.vue?vue&type=script&lang=js&"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=50879cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50879cbe",
  null
  
)

export default component.exports